import React from 'react';
import { Box, Container, useMediaQuery, useTheme } from '@mui/material';
import { Header } from './Header';
import Sidebar from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Box sx={{ display: { xs: 'block', md: 'flex' }, flexGrow: 1, py: 2 }}>
        {isDesktop && <Sidebar />}
        <Box component="main" sx={{ flexGrow: 1 }}>
          <Container maxWidth="lg">
            {children}
          </Container>
        </Box>
      </Box>
    </Box>
  );
};
